export default __webpack_public_path__ + "static/media/Vault-Logo-Animation.37dec61c.gif";